// src/components/Footer.jsx
import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Link,
  Flex,
  Icon,
  useColorModeValue
} from '@chakra-ui/react';
import { FaInstagram, FaTwitter, FaTiktok, FaFacebook } from 'react-icons/fa';
import { SiX } from 'react-icons/si'; // Ícone do X (ex-Twitter)
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';


const ListHeader = ({ children }) => {
  return (
    <Text fontWeight={'700'} fontSize={'lg'} mb={2} color="brand.primary">
      {children}
    </Text>
  );
};

const Footer = () => {
  // Obter a localização atual do usuário
  const location = useLocation();

  // Verificar se o usuário está na página inicial
  const isHomePage = location.pathname === '/';

  // Componente de link condicional que direciona para a home ou faz scroll
  const ConditionalLink = ({ to, children }) => {
    // Se estiver na página inicial, usa ScrollLink, caso contrário usa RouterLink para "/"
    if (isHomePage) {
      return (
        <ScrollLink to={to} smooth={true} duration={500} cursor="pointer">
          {children}
        </ScrollLink>
      );
    } else {
      return (
        <Link as={RouterLink} to={`/#${to}`}>
          {children}
        </Link>
      );
    }
  };

  return (
    <Box
      bg={useColorModeValue('white', 'gray.900')}
      borderTop={1}
      borderStyle={'solid'}
      borderColor={useColorModeValue('gray.200', 'gray.700')}
    >
      <Container maxW={'1200px'} py={10}>
        <SimpleGrid
          templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 1fr' }}
          spacing={8}
        >
          <Stack spacing={6} maxW={'300px'}>
            <Flex align="center">
              <Box as="img" src="/img/logo.png" alt="Draw Your Goods Logo" h="40px" mr={2} />
              <Text
                fontSize={'xl'}
                fontWeight={'bold'}
              >
                <Text as="span" color="brand.primary">Draw</Text>
                <Text as="span" color="brand.secondary"> Goods</Text>
              </Text>
            </Flex>
            <Text fontSize={'sm'} color={useColorModeValue('gray.600', 'gray.400')}>
              Transforme suas memórias em arte para colorir e reconecte-se com momentos especiais de uma forma única e relaxante.
            </Text>
            <Flex gap={4}>
              <Link href="https://www.facebook.com/profile.php?id=61576330400434" isExternal>
                <Icon as={FaFacebook} w={6} h={6} color="brand.primary" />
              </Link>
              <Link href="https://www.instagram.com/draw.goods/" isExternal>
                <Icon as={FaInstagram} w={6} h={6} color="brand.primary" />
              </Link>
              <Link href="https://www.tiktok.com/@drawrgoods" isExternal>
                <Icon as={FaTiktok} w={6} h={6} color="brand.primary" />
              </Link>
              <Link href="https://x.com/DrawGoods" isExternal>
                <Icon as={SiX} w={6} h={6} color="brand.primary" />
              </Link>
              <Link href="https://www.threads.com/@draw.goods" isExternal>
                <img
                  src="/img/icons/threads.png"
                  alt="Threads"
                  style={{
                    width: '24px',
                    height: '24px',
                    filter: 'brightness(0) saturate(100%) invert(61%) sepia(10%) saturate(800%) hue-rotate(204deg) brightness(98%) contrast(86%)'
                  }}
                />
              </Link>

            </Flex>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Links Rápidos</ListHeader>
            <ConditionalLink to="como-funciona">
              Como Funciona
            </ConditionalLink>
            <ConditionalLink to="exemplos">
              Exemplos
            </ConditionalLink>
            <ConditionalLink to="precos">
              Preços
            </ConditionalLink>
            <ConditionalLink to="faq">
              FAQ
            </ConditionalLink>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Informações</ListHeader>
            <Link as={RouterLink} to="/sobre-nos">Sobre Nós</Link>
            <Link as={RouterLink} to="/politica-de-privacidade">Política de Privacidade</Link>
            <Link as={RouterLink} to="/termos-de-uso">Termos de Uso</Link>
            <Link as={RouterLink} to="/contato">Contato</Link>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Contato</ListHeader>
            <Link href={'mailto:drawgoodscontato@gmail.com'}>drawgoodscontato@gmail.com</Link>
            <Link href={'tel:+5582991050175'}>+55 (82) 99105-0175</Link>
          </Stack>
        </SimpleGrid>
      </Container>
      <Box
        borderTopWidth={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.700')}
      >
        <Container
          maxW={'1200px'}
          py={4}
          textAlign={{ base: 'center', md: 'center' }}
        >
          <Text color={useColorModeValue('gray.600', 'gray.400')} fontSize={'sm'}>
            © {new Date().getFullYear()} Draw Your Goods. Todos os direitos reservados.
          </Text>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;